// Import Packages
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import JsonTree from 'autommate-react-json-viewer';

// Import Material UI Elements
import {
    Select,
    MenuItem,
    TextField,
    Checkbox,
} from '@material-ui/core';

// Import css
import './JsonViewer.css';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Returns     Component
 * @Author      Abdullah Onur Yeşil
 */
function JsonViewer({
                        assignValues,
                        setAssignValues,
                        variables,
                        setOpenVariable,
                        include,
                        exclude,
                        selectedVariable,
                        onVariableChange,
                        onVariableIndexChange,
                        showIndexInput,
                        setShowIndexInput,
                        indexValue,
                    }) {
    const {t} = useTranslation();
    const [variableList, setVariableList] = useState(variables);
    const [jsonData, setJsonData] = useState({});

    const label = 'CONTENT.CONFIGURATION-FORM.ADVANCED-ACTIONS.ADVANCED-ASSIGN.';

    useEffect(() => {
        updateVariable(selectedVariable);
    }, [selectedVariable]);

    useEffect(() => {
        let isInclude = false;
        if (include) {
            setVariableList(variables.filter((x) => include.includes(x.type)));
            isInclude = true;
        } else {
            setVariableList(variables);
        }
        if (exclude) {
            setVariableList(variables.filter((x) => !exclude.includes(x.type)));
        } else if (!isInclude) {
            setVariableList(variables);
        }
        if (selectedVariable?.type === 'Array') {
            setShowIndexInput(true);
        }

    }, [variables, include, setVariableList, exclude, selectedVariable?.type])

    const selectedData = (e, keyPath, key, type, hasParent, hasChild) => {
        let path = findKeyPath(keyPath);
        if (e.target.checked) {
            const isExist = assignValues.find(x => x.keyPath === path)
            if (!isExist) {
                setAssignValues([...assignValues, {
                    keyPath: path,
                    type: type.toLowerCase(),
                    set: "",
                    manipulations: [{}]
                }])
            }

        } else {
            let values = [...assignValues]; // make a separate copy of the array

            const index = values.findIndex(x => x.keyPath === path);
            if (index !== -1) {
                values.splice(index, 1);
                setAssignValues(values)
            }
        }
    }

    const findKeyPath = (keyPath) => {
        let path = selectedVariable.name;
        for (let i = 0; i < keyPath.length; i++) {
            path += `[${keyPath[i]}]`;
        }
        return path;
    }

    const updateVariable = (variable) => {
        if (selectedVariable.default_value) {
            setJsonData(JSON.parse(selectedVariable.default_value));
        }
    }

    return (
        <div>
            <h2>{t(label + 'JSON-VIEWER')}</h2>
            <div className="form-element" style={{margin: '0'}}>
                <div style={{marginBottom: '5px'}}><b>{t('CONTENT.AUTOMS-LIST.CHOOSE-VARIABLE')}</b></div>
                <Select value={selectedVariable} onChange={onVariableChange} variant="outlined" fullWidth
                        style={{marginBottom: 20, backgroundColor: '#FAFAFA'}}>
                    {variableList?.length > 0 && JSON.stringify(variableList[0]) !== '{}' ? variableList.map((item, itemI) =>
                            <MenuItem key={itemI} value={item}>{item.name}</MenuItem>
                        ) :
                        <MenuItem button onClick={() => setOpenVariable({type: "open", id: ""})}
                                  value="">{t('CONTENT.AUTOMS-LIST.ADD-NEW-VARIABLES')}</MenuItem>
                    }
                </Select>
                {showIndexInput &&
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <div>{t('CONTENT.CONFIGURATION-FORM.INDEX')}</div>
                    <TextField
                        variant="outlined"
                        onChange={onVariableIndexChange}
                        value={indexValue} type="number"
                    />
                </div>
                }
            </div>
            {jsonData && Object.keys(jsonData).length > 0 &&
            <JsonTree data={jsonData} expandable={true}
                      labelRender={(keyPath, key, type, hasParent, hasChild) => <span><Checkbox
                          checked={assignValues.find(x => x.keyPath === findKeyPath(keyPath))}
                          onChange={(e) => selectedData(e, keyPath, key, type, hasParent, hasChild)}
                          size='small'/>
                          <span className="top-2">
                              <strong>"{key}"</strong> :
                          </span>
                      </span>
                      }
            />
            }
            {jsonData && Object.keys(jsonData).length === 0 &&
            <div className="no-json-view">{t(label + "NO-JSON-VIEW")}</div>
            }
        </div>
    );
}

export default JsonViewer;
